import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const CREATE_DIVISION = gql`
  mutation CreateAccountDivision($input: CreateAccountDivisionInput!) {
    createAccountDivision(input: $input) {
      id
      name
      description
      video_url
      image
      image_id
    }
  }
`;

export function useCreateDivision() {
  const [createDivisionMutation, { loading }] = useMutation(CREATE_DIVISION);

  const createDivision = useCallback(
    async (input) => {
      try {
        const result = await createDivisionMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.createAccountDivision };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [createDivisionMutation]
  );

  return { createDivision, loading };
}
